import { DeviceType } from './types.ts'

interface DeviceProps {
  device: DeviceType
}

export default function Device({ device }: DeviceProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Nom :</strong>
        {device.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Communauté :</strong>
        {device.community_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Utilisateur :</strong>
        {(device.assigned_agent_name || device.user_id)?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Numéro de série :</strong>
        {device.serial_number?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Imei:</strong>
        {device.imei?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Statut :</strong>
        {device.status?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Dernière synchronisation :</strong>
        {device.last_sync_at?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Actif :</strong>
        {device.active?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Total paiements :</strong>
        {(device.total_payments_count || 0).toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Montant du jour :</strong>
        {Number(device.today_collected_amount || 0).toFixed(2)} FCFA
      </p>
    </div>
  )
}
